import { Inject, Injectable } from '@angular/core';
import { ScrudgRevisionService } from '../base/scrudg-revision/scrudg-revision.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReadResult } from '../../models/net/result/crud/read-result';
import { HttpFactory } from '../../utilities/http-factory';
import { ArticleSearchResult } from '../../models/net/result/article-search-result';

@Injectable({
    providedIn: 'root'
})

export class ArticleService extends ScrudgRevisionService {

    public constructor(public override http: HttpClient, @Inject("API_BASE_URL") apiBaseUrl: string) {

        super(http, apiBaseUrl, "article");
    }

    public anonSearch<TRequest, TResult>(request: TRequest): Observable<TResult[] | null> {

        const result = HttpFactory.anonPost<any>(this.http, request, this._controllerName + "/searchanonymous", this._apiBaseUrl);

        return result;
    }

    public anonGetByHtmlContentId(htmlContentId: number): Observable<ArticleSearchResult | null> {

        const result = HttpFactory.anonGet<ArticleSearchResult | null>(this.http, this._controllerName + "/getAnonymousByHtmlContentId/" + htmlContentId, this._apiBaseUrl);

        return result;
    }

    public anonGetByMoniker(moniker: string): Observable<ArticleSearchResult | null> {

        const result = HttpFactory.anonGet<ArticleSearchResult | null>(this.http, this._controllerName + "/getAnonymousByHtmlMoniker/" + moniker, this._apiBaseUrl);

        return result;
    }
}
